import { KontaktItem } from './kontakt-item';

export class Schaltleitung {
    public id: number;
    public kuerzel: string;
    public email: string;
    public name: string;
    public adresse?: string;
    public kontakte: KontaktItem[] = [];
}
